import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name : "ReplaceQuotes"
})

export class ReplaceQuotesPipe implements PipeTransform{
	transform(value: string): string{
		return value.replace(/%22/g, '"');
	}
}



// WEBPACK FOOTER //
// C:/dev/um.stamps/src/app/shared/pipes/replace-quotes.pipe.ts